// extracted by mini-css-extract-plugin
export default {"image":"oX-z","loaded":"pX-z"};